var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMissedSessionsIcon = function SvgMissedSessionsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 0C5.292 0 0.375 4.917 0.375 11C0.375 17.083 5.292 22 11.375 22C17.458 22 22.375 17.083 22.375 11C22.375 4.917 17.458 0 11.375 0ZM11.375 19.8C6.524 19.8 2.575 15.851 2.575 11C2.575 6.149 6.524 2.2 11.375 2.2C16.226 2.2 20.175 6.149 20.175 11C20.175 15.851 16.226 19.8 11.375 19.8ZM15.324 5.5L11.375 9.449L7.426 5.5L5.875 7.051L9.824 11L5.875 14.949L7.426 16.5L11.375 12.551L15.324 16.5L16.875 14.949L12.926 11L16.875 7.051L15.324 5.5Z",
    fill: "#D85E62"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMissedSessionsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "missed-sessions-icon.6535cb7c335a348e459e473418d30189.svg";